@switch (selectedTool$ | async) {
  @case ('Edit') {
    <h3-edit-tool-2d-secondary-toolbar
      [videoOutputName]="videoOutputName"
    ></h3-edit-tool-2d-secondary-toolbar>
  }
}
